import IdealStudio from "./main";
import BasePlugin from "./base_plugin";
import { extensions } from "../../common/constants";
import { TRANSLATED_LANGUAGES } from "../../common/content_language";
export default function () {
  let pluginInstancesList = {};
  let pluginConfigs = [];
  return {
    get: function (name) {
      return pluginInstancesList[name];
    },
    getAll: function () {
      return pluginInstancesList;
    },
    loadAll: function (lang) {
      pluginConfigs = [];
      IdealStudio.Config.pluginFileMap = {};
      extensions.map((ext) => {
        IdealStudio.Config.pluginFileMap[ext] = {};
      });
      IdealStudio.Config.pluginList.map((id) => {
        try {
          let plugin = new BasePlugin();
          IdealStudio.Plugins[id] = require("./../../plugins/" + id + "/" + id)[id](plugin);

          plugin.create(IdealStudio.Plugins[id]);
          plugin.init();
          // Quiz chrome may render in a language other than the UI's.
          plugin.getLocales(lang);
          TRANSLATED_LANGUAGES.forEach((l) => plugin.getLocales(l));
          pluginInstancesList[id] = plugin;
          let config = plugin.getConfig();
          if (config.createFromLibrary) {
            let lib = config.createFromLibrary;
            let mime = "all";
            let key = "url";
            if (lib instanceof Array) {
              mime = lib[0] || mime;
              key = lib[1] || key;
            }
            let allowedExtensions = extensions.filter((ext) => {
              return mime.match(ext);
            });
            allowedExtensions.map((ext) => {
              IdealStudio.Config.pluginFileMap[ext][id] = key;
            });
          }
          pluginConfigs.push(config);
          // plugin.getConfig().callback({}, 'INIT');

          IdealStudio.Visor.Plugins.add(id, lang);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      });
    },
    getPluginConfigs: function () {
      return pluginConfigs;
    },
  };
}
